import i18next from "i18next";

/**
 * Nome do grupo DRE na língua da tela, a partir do valor do enum (ex.: CUSTO_VARIAVEL vira
 * "Custo Variável").
 *
 * Único lugar que traduz o grupo: lista de categorias, seletor de categoria, contas a pagar e
 * receber e o formulário da conta usam daqui. Antes cada tela tinha a própria conversão, e a
 * lista de categorias ficou sem nenhuma, mostrando o código do enum.
 *
 * Sem tradução cadastrada devolve o próprio valor, para um grupo novo aparecer com o código em
 * vez de sumir da tela.
 *
 * @returns {string|null} o nome traduzido, ou null quando não há grupo.
 */
export const formatDreGroup = (dreGroup) => {
    if (!dreGroup) {
        return null;
    }
    const key = `cash_flow.dre_groups.${String(dreGroup).toLowerCase()}`;
    return i18next.exists(key) ? i18next.t(key) : dreGroup;
};
